<mat-toolbar color="accent">{{ title }}</mat-toolbar>
<mat-dialog-content>
  <pr-notes [resource]="data.notable" [addNoteBottom]="true" />
</mat-dialog-content>
